// Root-header quick action; shared theme state keeps Settings and every root in sync.
import { Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@/hooks/useTheme';

export function ThemeToggle() {
  const { i18n } = useTranslation();
  const { resolvedTheme, setTheme } = useTheme();
  const zh = i18n.language.startsWith('zh');
  const dark = resolvedTheme === 'dark';
  const label = dark
    ? (zh ? '切换到宝石蓝' : 'Switch to sapphire light')
    : (zh ? '切换到石墨深色' : 'Switch to graphite dark');
  const Icon = dark ? Sun : Moon;
  return <button type="button" onClick={() => setTheme(dark ? 'light' : 'dark')} aria-label={label} title={label} className="inline-flex min-h-[44px] min-w-[44px] shrink-0 items-center justify-center rounded-xl bg-white/10 text-white transition-colors hover:bg-white/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/80 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent">
    <Icon className="h-5 w-5" aria-hidden="true" />
  </button>;
}
